import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, provideZoneChangeDetection } from '@angular/core';
import { RouterModule } from '@angular/router';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ToastrModule } from 'ngx-toastr';
import { CommonModule } from '@angular/common';
import { SidebarModule } from '@layouts/sidebar/sidebar.module';
import { NavbarModule} from '@layouts/navbar/navbar.module';
import { FixedPluginModule} from '@shared/fixedplugin/fixedplugin.module';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { AppComponent } from './app.component';
import { AppRoutes } from './app.routing';
import { AdminLayoutComponent } from '@layouts/admin-layout/admin-layout.component';
import { ConfirmComponent } from '@shared/modals/confirm/confirm.component';
import { InformationComponent } from '@shared/modals/information/information.component';
import { PreviewComponent } from '@shared/modals/preview/preview.component';
import { TimedComponent } from '@shared/modals/timed/timed.component';
import { LoginComponent } from '@core/login/login.component';
import { AuthGuard } from '@shared/services/guards/auth-guard.service';
import { CanDeactivateGuard } from '@app/shared/services/guards/deactivate-guard.service';
import { AuthInterceptor } from '@shared/services/http/auth.inteceptor';
import { SharedModule } from '@shared/shared.module';
import {CustomComponentsModule} from '@shared/customcomponents.module';
import { PasswordExpiryComponent } from './password-expiry/password-expiry.component';



@NgModule({ declarations: [
        AppComponent,
        AdminLayoutComponent,
        ConfirmComponent,
        InformationComponent,
        LoginComponent,
        PreviewComponent,
        TimedComponent,
        PasswordExpiryComponent,
    ],
    bootstrap: [AppComponent],
    exports: [
        ConfirmComponent
    ], imports: [BrowserAnimationsModule,
        RouterModule.forRoot(AppRoutes, {}),
        CommonModule,
        SidebarModule,
        NavbarModule,
        ToastrModule.forRoot(),
        FixedPluginModule,
        SharedModule,
        FormsModule,
        ReactiveFormsModule,
        CustomComponentsModule], providers: [
        AuthGuard,
        CanDeactivateGuard,
        provideZoneChangeDetection(),
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true
        },
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule { }
